package com.parmartechnologies.core.navigation

import com.parmartechnologies.core.feature.address.model.Address
import com.parmartechnologies.core.feature.auth.model.FriendlyUser
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.feature.businessType.model.BusinessType
import com.parmartechnologies.core.feature.chat.conversation.model.Conversation
import com.parmartechnologies.core.feature.customer.model.Customer
import com.parmartechnologies.core.feature.employee.model.Employee
import com.parmartechnologies.core.feature.inventory.brand.model.Brand
import com.parmartechnologies.core.feature.inventory.color.model.ProductColor
import com.parmartechnologies.core.feature.inventory.coupon.model.Coupon
import com.parmartechnologies.core.feature.inventory.discount.model.Discount
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import com.parmartechnologies.core.feature.inventory.size.model.Size
import com.parmartechnologies.core.feature.inventory.tag.model.Tag
import com.parmartechnologies.core.feature.inventory.uom.model.UOM
import com.parmartechnologies.core.feature.order.model.Order
import com.parmartechnologies.core.feature.product.model.Product
import com.parmartechnologies.core.feature.productCategory.model.ProductCategory
import com.parmartechnologies.core.feature.productSubCategory.model.ProductSubCategory
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

@Serializable
data class NavigationParam @OptIn(ExperimentalTime::class) constructor(
    @SerialName("_id") var _id: String = "",
    @SerialName("url") var url: String = "",
    @SerialName("unique_id") var uniqueID: String = "",
    @SerialName("User") var user: FriendlyUser = FriendlyUser(),
    @SerialName("Business") var business: Business = Business(),
    @SerialName("BusinessType") var businessType: BusinessType = BusinessType(),
    @SerialName("selected_business") var selectedBusiness: Business = Business(),
    @SerialName("Customer") var customer: Customer = Customer(),
    @SerialName("Employee") var employee: Employee = Employee(),
    @SerialName("product") var product: Product = Product(),
    @SerialName("Order") var order: Order = Order(),
    @SerialName("ProductCategory") var productCategory: ProductCategory = ProductCategory(),
    @SerialName("ProductSubCategory") var productSubCategory: ProductSubCategory = ProductSubCategory(),
    @SerialName("inventory") var inventory: Inventory = Inventory(),
    @SerialName("address") var address: Address = Address(),
    @SerialName("brand") var brand: Brand = Brand(),
    @SerialName("Tag") var tag: Tag = Tag(),
    @SerialName("Size") var size: Size = Size(),
    @SerialName("UOM") var uom: UOM = UOM(),
    @SerialName("ProductColor") var pColor: ProductColor = ProductColor(),
    @SerialName("coupon") var coupon: Coupon = Coupon(),
    @SerialName("discount") var discount: Discount = Discount(),
    @SerialName("Conversation") var conversation: Conversation = Conversation(),

    ) {
    fun update(params: NavigationParam?): NavigationParam {
        if (params != null) {
            _id = params._id
            url = params.url
            uniqueID = params.uniqueID
            business = params.business
            businessType = params.businessType
            selectedBusiness = params.selectedBusiness
            customer = params.customer
            employee = params.employee
            product = params.product
            order = params.order
            productCategory = params.productCategory
            productSubCategory = params.productSubCategory
            inventory = params.inventory
            address = params.address
            brand = params.brand
            tag = params.tag
            size = params.size
            uom = params.uom
            pColor = params.pColor
            coupon = params.coupon
            discount = params.discount
            conversation = params.conversation

        }
        return this
    }
}